import { callServiceMachine } from '_core/util';
import Machines from '../Machines';
import { IMessageResponse } from '_core/types';
import { ValidateEmailRegisterTypes } from '../Types';

const machine = Machines.onValidateEmail.machine;

export const validateEmail = (
  params: ValidateEmailRegisterTypes.ValidateEmailServiceRequestType,
): Promise<IMessageResponse> => {
  return callServiceMachine(machine, params);
};

export default { validateEmail };
